(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[662],{

/***/ 2937:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/author/[author]",
      function () {
        return __webpack_require__(6741);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ Flex; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6220);
/* harmony import */ var _Flex_module_sass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4017);
/* harmony import */ var _Flex_module_sass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Flex_module_sass__WEBPACK_IMPORTED_MODULE_3__);





function Flex(props) {
    const isMobile = (0,_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("(max-width: 768px)");
    var _props_marginTop;
    const marginTop = (_props_marginTop = props.marginTop) !== null && _props_marginTop !== void 0 ? _props_marginTop : 0;
    var _props_marginBottom;
    const marginBottom = (_props_marginBottom = props.marginBottom) !== null && _props_marginBottom !== void 0 ? _props_marginBottom : 0;
    const perRow = isMobile ? props.mobileItemsPerRow : props.itemsPerRow;
    const itemWidth = perRow ? 100 / perRow : null;
    const space = props.spacing ? props.spacing / 2 : 0;
    var _props_justifyContent, _props_alignItems;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Flex_module_sass__WEBPACK_IMPORTED_MODULE_3___default().wrapper),
        style: {
            width: "calc(100% + ".concat(space * 2, "px)"),
            marginLeft: "-".concat(space, "px"),
            "--Flex-margin-top": "".concat(marginTop - space, "px"),
            marginBottom: "".concat(marginBottom - space, "px")
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_Flex_module_sass__WEBPACK_IMPORTED_MODULE_3___default().inner),
            style: {
                justifyContent: (_props_justifyContent = props.justifyContent) !== null && _props_justifyContent !== void 0 ? _props_justifyContent : "flex-start",
                alignItems: (_props_alignItems = props.alignItems) !== null && _props_alignItems !== void 0 ? _props_alignItems : "flex-start"
            },
            children: react__WEBPACK_IMPORTED_MODULE_1__.Children.map(react__WEBPACK_IMPORTED_MODULE_1__.Children.toArray(props.children), (child)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((_Flex_module_sass__WEBPACK_IMPORTED_MODULE_3___default().item)),
                    style: itemWidth ? {
                        width: "calc(".concat(itemWidth, "% - ").concat(space * 2, "px)"),
                        margin: "".concat(space, "px")
                    } : {
                        width: "auto",
                        margin: "0 ".concat(space, "px")
                    },
                    children: child
                }))
        })
    });
}


/***/ }),

/***/ 2170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ ProfileBadge; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6010);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _generated_content__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1360);
/* harmony import */ var _Buttons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2405);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3);
/* harmony import */ var _Likes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4119);
/* harmony import */ var _ProfileBadge_module_sass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8169);
/* harmony import */ var _ProfileBadge_module_sass__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_ProfileBadge_module_sass__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _UserBadge__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8645);










const ProfileBadge = (param)=>{
    let { type , image , name , statistics , userId  } = param;
    const locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    var _image_alt, _ref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((_ProfileBadge_module_sass__WEBPACK_IMPORTED_MODULE_9___default().wrapper), (_ProfileBadge_module_sass__WEBPACK_IMPORTED_MODULE_9___default())["is_".concat(type)]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_ProfileBadge_module_sass__WEBPACK_IMPORTED_MODULE_9___default().main),
            children: type === "public" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UserBadge__WEBPACK_IMPORTED_MODULE_7__/* .UserBadge */ .s, {
                        name: name,
                        image: image,
                        size: "big",
                        isHighlighted: true,
                        link: {
                            type: _generated_content__WEBPACK_IMPORTED_MODULE_3__/* .LinkType.external */ .Un.external,
                            externalLink: "/author/".concat(userId)
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProfileBadgeStatistics, {
                        ...statistics
                    })
                ]
            }) : type === "profile" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_ProfileBadge_module_sass__WEBPACK_IMPORTED_MODULE_9___default().image),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                            src: image.url,
                            layout: "fill",
                            objectFit: "cover",
                            alt: (_ref = (_image_alt = image.alt) !== null && _image_alt !== void 0 ? _image_alt : image.description) !== null && _ref !== void 0 ? _ref : "",
                            placeholder: "blur",
                            blurDataURL: image.url
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_ProfileBadge_module_sass__WEBPACK_IMPORTED_MODULE_9___default().content),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: (_ProfileBadge_module_sass__WEBPACK_IMPORTED_MODULE_9___default().name),
                                children: name
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_ProfileBadge_module_sass__WEBPACK_IMPORTED_MODULE_9___default().contentIn),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProfileBadgeStatistics, {
                                        ...statistics
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Buttons__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, {
                                        href: "/user/edit",
                                        type: "link",
                                        fill: "empty",
                                        isBorder: true,
                                        children: locale === "cs" ? "Upravit profil" : "Edit profile"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : null
        })
    });
};
const ProfileBadgeStatistics = (param)=>{
    let { likes =0 , plants =0  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_ProfileBadge_module_sass__WEBPACK_IMPORTED_MODULE_9___default().statistics),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((_ProfileBadge_module_sass__WEBPACK_IMPORTED_MODULE_9___default().statisticsItem), (_ProfileBadge_module_sass__WEBPACK_IMPORTED_MODULE_9___default().is_likes)),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Likes__WEBPACK_IMPORTED_MODULE_6__/* .Likes */ .d, {
                        count: likes,
                        isNotButton: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_ProfileBadge_module_sass__WEBPACK_IMPORTED_MODULE_9___default().tooltip),
                        children: "Likes"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((_ProfileBadge_module_sass__WEBPACK_IMPORTED_MODULE_9___default().statisticsItem), (_ProfileBadge_module_sass__WEBPACK_IMPORTED_MODULE_9___default().is_plants)),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_ProfileBadge_module_sass__WEBPACK_IMPORTED_MODULE_9___default().icon),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_5__/* .Icon */ .J, {
                            name: "plant"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: plants
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_ProfileBadge_module_sass__WEBPACK_IMPORTED_MODULE_9___default().tooltip),
                        children: "Plant profiles"
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 7647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ SectionToggler; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _SectionToggler_module_sass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(885);
/* harmony import */ var _SectionToggler_module_sass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_SectionToggler_module_sass__WEBPACK_IMPORTED_MODULE_2__);




function SectionToggler(props) {
    const [activeIndex, setActiveIndex] = react__WEBPACK_IMPORTED_MODULE_1__.useState(0);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_SectionToggler_module_sass__WEBPACK_IMPORTED_MODULE_2___default().wrapper),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_SectionToggler_module_sass__WEBPACK_IMPORTED_MODULE_2___default().nav),
                children: props.headings.map((heading, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((_SectionToggler_module_sass__WEBPACK_IMPORTED_MODULE_2___default().heading), activeIndex === index && (_SectionToggler_module_sass__WEBPACK_IMPORTED_MODULE_2___default().active)),
                        onClick: ()=>{
                            setActiveIndex(index);
                        },
                        children: heading
                    }, index))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_SectionToggler_module_sass__WEBPACK_IMPORTED_MODULE_2___default().inner),
                children: react__WEBPACK_IMPORTED_MODULE_1__.Children.map(react__WEBPACK_IMPORTED_MODULE_1__.Children.toArray(props.children), (child, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((_SectionToggler_module_sass__WEBPACK_IMPORTED_MODULE_2___default().item), activeIndex === index && (_SectionToggler_module_sass__WEBPACK_IMPORTED_MODULE_2___default().active)),
                        children: child
                    }))
            })
        ]
    });
}


/***/ }),

/***/ 195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ filterNonEmpty; }
/* harmony export */ });
function filterNonEmpty(value) {
    return value !== null && value !== undefined;
}


/***/ }),

/***/ 6741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ AuthorPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./app/utils/filterNonEmpty.ts
var filterNonEmpty = __webpack_require__(195);
// EXTERNAL MODULE: ./app/components/Author.module.sass
var Author_module = __webpack_require__(8045);
var Author_module_default = /*#__PURE__*/__webpack_require__.n(Author_module);
// EXTERNAL MODULE: ./app/components/CardPlant.tsx + 1 modules
var CardPlant = __webpack_require__(7132);
// EXTERNAL MODULE: ./app/components/Container.tsx
var Container = __webpack_require__(2537);
// EXTERNAL MODULE: ./app/components/Flex.tsx
var Flex = __webpack_require__(9129);
// EXTERNAL MODULE: ./app/components/Icon.tsx + 36 modules
var Icon = __webpack_require__(3);
// EXTERNAL MODULE: ./app/components/ProfileBadge.tsx
var ProfileBadge = __webpack_require__(2170);
// EXTERNAL MODULE: ./app/components/SectionToggler.tsx
var SectionToggler = __webpack_require__(7647);
;// CONCATENATED MODULE: ./app/components/Author.tsx











function Author(props) {
    var _props_author_avatar, _props_author_nick;
    //const plantee = usePlanteeUser()
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)((Author_module_default()).wrapper),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
            view: "wide",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Author_module_default()).inner,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                        href: "/",
                        className: (Author_module_default()).backLink,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                name: "arrowleft"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Back to plant profiles"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                        justifyContent: "center",
                        marginTop: 40,
                        marginBottom: 50,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileBadge/* ProfileBadge */.b, {
                            image: (_props_author_avatar = props.author.avatar) !== null && _props_author_avatar !== void 0 ? _props_author_avatar : {
                                url: "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png",
                                id: "0"
                            },
                            name: (_props_author_nick = props.author.nick) !== null && _props_author_nick !== void 0 ? _props_author_nick : "",
                            type: "public",
                            statistics: {
                                likes: props.author.likedPlantProfiles.length,
                                plants: props.plantProfiles.length
                            },
                            userId: String(props.author.id)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionToggler/* SectionToggler */.t, {
                        headings: [
                            "Plant profiles ".concat(props.plantProfiles.length),
                            "About"
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                                spacing: 20,
                                itemsPerRow: 5,
                                mobileItemsPerRow: 2,
                                marginTop: 50,
                                children: props.plantProfiles.map((item, index)=>{
                                    var _item_activeRevision, _item_activeRevision_images, _item_activeRevision1, _item_activeRevision_localesByLocale, _item_author, _item_author1, _item_author2, _item_author3, _item_author4;
                                    const images = (_item_activeRevision = item.activeRevision) === null || _item_activeRevision === void 0 ? void 0 : (_item_activeRevision_images = _item_activeRevision.images) === null || _item_activeRevision_images === void 0 ? void 0 : _item_activeRevision_images.items.sort((a, b)=>{
                                        var _b_image, _a_image;
                                        return Number((_b_image = b.image) === null || _b_image === void 0 ? void 0 : _b_image.isThumbnail) - Number((_a_image = a.image) === null || _a_image === void 0 ? void 0 : _a_image.isThumbnail);
                                    });
                                    var _images_map_filter, _item_activeRevision_localesByLocale_name, _ref;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardPlant/* CardPlant */.e, {
                                        images: (_images_map_filter = images === null || images === void 0 ? void 0 : images.map((item)=>item.image).filter(filterNonEmpty/* filterNonEmpty */.y)) !== null && _images_map_filter !== void 0 ? _images_map_filter : [],
                                        title: (_item_activeRevision_localesByLocale_name = (_item_activeRevision1 = item.activeRevision) === null || _item_activeRevision1 === void 0 ? void 0 : (_item_activeRevision_localesByLocale = _item_activeRevision1.localesByLocale) === null || _item_activeRevision_localesByLocale === void 0 ? void 0 : _item_activeRevision_localesByLocale.name) !== null && _item_activeRevision_localesByLocale_name !== void 0 ? _item_activeRevision_localesByLocale_name : "",
                                        user: {
                                            name: (_ref = ((_item_author = item.author) === null || _item_author === void 0 ? void 0 : _item_author.nick) || ((_item_author1 = item.author) === null || _item_author1 === void 0 ? void 0 : _item_author1.email)) !== null && _ref !== void 0 ? _ref : "",
                                            image: (_item_author2 = item.author) === null || _item_author2 === void 0 ? void 0 : _item_author2.avatar,
                                            id: String((_item_author3 = item.author) === null || _item_author3 === void 0 ? void 0 : _item_author3.id)
                                        },
                                        likes: 1,
                                        link: "/profile/".concat((_item_author4 = item.author) === null || _item_author4 === void 0 ? void 0 : _item_author4.id, "/").concat(item.id)
                                    }, index);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (Author_module_default()).about,
                                children: props.author.label
                            })
                        ]
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./app/components/Footer.tsx + 1 modules
var Footer = __webpack_require__(7082);
// EXTERNAL MODULE: ./app/components/Nav.tsx + 1 modules
var Nav = __webpack_require__(1799);
// EXTERNAL MODULE: ./app/components/PageInfo.tsx
var PageInfo = __webpack_require__(5358);
;// CONCATENATED MODULE: ./pages/author/[author].tsx





var __N_SSP = true;
function AuthorPage(props) {
    var _props_data_getUser, _props_data_getUser1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageInfo/* PageInfo */.S, {
                title: ((_props_data_getUser = props.data.getUser) === null || _props_data_getUser === void 0 ? void 0 : _props_data_getUser.nick) || ((_props_data_getUser1 = props.data.getUser) === null || _props_data_getUser1 === void 0 ? void 0 : _props_data_getUser1.email) || ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* Nav */.J, {}),
            props.data.getUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(Author, {
                author: props.data.getUser,
                plantProfiles: props.data.listPlantProfile
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* Footer */.$, {})
        ]
    });
}


/***/ }),

/***/ 8045:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Author_wrapper__Y8kcF","about":"Author_about__JFHgO","inner":"Author_inner___JpUL","backLink":"Author_backLink__9vb63"};

/***/ }),

/***/ 4017:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Flex_wrapper__1kICk","inner":"Flex_inner__z2K8_","item":"Flex_item__7CXlR"};

/***/ }),

/***/ 8169:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProfileBadge_wrapper__Kw8Ew","is_public":"ProfileBadge_is_public__8amC6","main":"ProfileBadge_main__APPPd","is_profile":"ProfileBadge_is_profile__LYgZq","content":"ProfileBadge_content__w9sND","contentIn":"ProfileBadge_contentIn__0aJ15","name":"ProfileBadge_name__zKsu9","image":"ProfileBadge_image__fucG0","statistics":"ProfileBadge_statistics__SxL2K","statisticsItem":"ProfileBadge_statisticsItem__rOKA_","is_duplications":"ProfileBadge_is_duplications__06H2Q","is_plants":"ProfileBadge_is_plants__zpslt","icon":"ProfileBadge_icon__vWPOl","tooltip":"ProfileBadge_tooltip__R7pmK"};

/***/ }),

/***/ 885:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SectionToggler_wrapper__btZXF","nav":"SectionToggler_nav__SiDqv","heading":"SectionToggler_heading__nLNv7","active":"SectionToggler_active__Kclpj","item":"SectionToggler_item__AGepD"};

/***/ }),

/***/ 1900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ ButtonBase; }
/* harmony export */ });
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var assertNever = function (_) {
    throw new Error(JSON.stringify(_));
};

var ButtonBase = (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_a, ref) {
    var children = _a.children, className = _a.className, id = _a.id, tabIndex = _a.tabIndex, onClick = _a.onClick, onPointerDown = _a.onPointerDown, style = _a.style, title = _a.title, otherProps = __rest(_a, ["children", "className", "id", "tabIndex", "onClick", "onPointerDown", "style", "title"]);
    var commonProps = {
        className: className,
        id: id,
        tabIndex: tabIndex,
        onClick: onClick,
        onPointerDown: onPointerDown,
        style: style,
        title: title,
    };
    if (otherProps.type === 'button' ||
        otherProps.type === 'submit' ||
        otherProps.type === 'reset') {
        return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("button", __assign({}, commonProps, { type: otherProps.type, disabled: otherProps.disabled, ref: ref }), children));
    }
    else if (otherProps.type === 'link') {
        var anchorProps = __assign(__assign({}, commonProps), { target: otherProps.target, rel: otherProps.rel, ref: ref });
        return (react__WEBPACK_IMPORTED_MODULE_1__.createElement((next_link__WEBPACK_IMPORTED_MODULE_0___default()), { href: otherProps.href, as: otherProps.as, replace: otherProps.replace, scroll: otherProps.scroll, shallow: otherProps.shallow, passHref: otherProps.passHref, prefetch: otherProps.prefetch, locale: otherProps.locale, legacyBehavior: true },
            react__WEBPACK_IMPORTED_MODULE_1__.createElement("a", __assign({}, anchorProps), children)));
    }
    else {
        assertNever(otherProps);
    }
    return null;
});


//# sourceMappingURL=index.es.js.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [407,755,32,424,3,251,941,132,469,774,888,179], function() { return __webpack_exec__(2937); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);